export default function getRandom8DigitString() {
  return Math.floor(10000000 + Math.random() * 90000000).toString();
}
